import { useMutation, useQueryClient } from "@tanstack/react-query";
import { broadcastMessages, BroadcastMessagesPayload } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useBroadcastMessages = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: BroadcastMessagesPayload) =>
      broadcastMessages(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.Chats],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
